<!--Directory Source selection-->
<app-directory-search-selection #directorySearchSource (selectedDirectorySource)="onOpenDirectorySearch($event)"
    [doNotResetScrollOnClose]="doNotResetScrollOnClose">
</app-directory-search-selection>

<!--Search Kno2 directory-->
<app-directory-search-kno2 [dialogOpened]="kno2DirectoryDialogOpened" [allowSelection]="allowSelection"
    [showOrganizationsTab]="showOrganizationsTab" [disableEscape]="disableEscape"
    [singleSelectionOnly]="singleSelectionOnly" [doNotResetScrollOnClose]="doNotResetScrollOnClose"
    (selectProvider)="onSelectProviders($event)" (closing)="kno2DirectoryDialogOpened=false;">
</app-directory-search-kno2>

<!--Search Channels directory-->
<app-directory-search-channels [dialogOpened]="channelsDirectoryDialogOpened" [allowSelection]="allowSelection"
    [allowFacilitySearch]="allowFacilitySearch" [disableEscape]="disableEscape"
    [singleSelectionOnly]="singleSelectionOnly" [memberId]="memberId"
    [doNotResetScrollOnClose]="doNotResetScrollOnClose" (selectProvider)="onSelectProviders($event)"
    (closing)="channelsDirectoryDialogOpened=false;">
</app-directory-search-channels>